import { observer } from 'mobx-react-lite';
import StickyLinkButton from '@features/productPreview/sections/StickyBar/components/StickyLinkButton/StickyLinkButton';
import { STICKYBAR_MAP, VisibleSectionType } from '@features/productPreview/const';
type PropTypes = {
  stickyBarLinks: Array<string>;
};
const StickyDesktopLinks = ({
  stickyBarLinks
}: PropTypes) => {
  const linksToRender = stickyBarLinks.map((link: string) => VisibleSectionType[link]).filter((type: VisibleSectionType) => type !== null).map((type: VisibleSectionType) => {
    if (!STICKYBAR_MAP.get(type)) {
      return null;
    }
    return <StickyLinkButton key={type} type={type} data-cy="StickyLinkButton" />;
  });
  return <>{linksToRender}</>;
};
export default observer(StickyDesktopLinks);